import { Sparkles, ArrowRight } from 'lucide-react';

export interface ActionRequiredBannerProps {
  title: string;
  description?: string;
  onAction?: () => void;
  actionLabel?: string;
  /** Rendered uppercase. */
  eyebrow?: string;
}

/**
 * Today's review card ("Today Update Card" in Figma). Copy per YAR-478:
 * eyebrow READY TO REVIEW (was ACTION REQUIRED — a pressure word), button
 * "Review" (was "Review now").
 */
export function ActionRequiredBanner({
  title,
  description,
  onAction,
  actionLabel = 'Review',
  eyebrow = 'Ready to review',
}: ActionRequiredBannerProps) {
  return (
    <div
      className="rounded-xl p-5 shadow-[0px_0px_4px_0px_rgba(56,64,74,0.06)]"
      style={{
        background:
          'linear-gradient(to top right, var(--color-primary, #264133), var(--color-primary-light, #e6f1ec))',
      }}
    >
      <div className="flex flex-col items-start gap-3">
        <div className="flex items-center gap-2">
          <Sparkles
            size={20}
            className="text-primary-foreground"
          />
          <span className="text-sm font-bold uppercase text-primary-foreground">
            {eyebrow}
          </span>
        </div>

        <h3 className="text-[32px] font-bold leading-10 text-background">
          {title}
        </h3>

        {description && (
          <p className="text-xl leading-7 text-background">{description}</p>
        )}

        {onAction && (
          <button
            type="button"
            onClick={onAction}
            className={[
              'mt-1 inline-flex items-center gap-1.5 self-start',
              'rounded-md px-2 py-1.5',
              'bg-background text-foreground',
              'border border-border',
              'text-base font-semibold',
              'cursor-pointer',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {actionLabel}
            <ArrowRight
              size={16}
              className="text-icon-default"
            />
          </button>
        )}
      </div>
    </div>
  );
}
